import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATE, DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'holiday'

  static get fields () {
    return {
      id: new UUID(),
      date: new DATE(),
      name: new STRING(),
      state: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_at: new DATETIME()
    }
  }
}
